import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, Shapeable } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityPillarCard, EntityPillarCardProps } from '@shapeable/ui';
import { Link } from '@shapeable/villars-types';
import { VERY_LIGHT_BROWN } from '../../theme';

const cls = classNames('link-pillar-card');

// -------- Types -------->

// -------- Props -------->

export type LinkPillarCardProps = Classable & EntityPillarCardProps & { 
  entity?: Link;
};

export const LinkPillarCardDefaultProps: Omit<LinkPillarCardProps, 'entity'> = {
  
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(EntityPillarCard)<ContainerProps>`${ContainerStyles}`,
};

export const LinkPillarCard: Shapeable.FC<LinkPillarCardProps> = (props) => {
  const { 
    className, entity, 
  } = props;
  
  return (
    <My.Container 
      className={cls.name(className)}
      entity={entity}
      colors={{
        background: VERY_LIGHT_BROWN,
        text: 'text',
        border: entity?.color?.value || 'primary',
        fill: 'primary',
      }} 
      />
  )
};

LinkPillarCard.defaultProps = LinkPillarCardDefaultProps;
LinkPillarCard.cls = cls;